(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-order-sample-button]');

      if (!button) return;

      event.preventDefault();

      var sampleVariantId = button.getAttribute('data-sample-variant-id');
      var parentProductId = button.getAttribute('data-sample-parent-product-id');
      var parentProductTitle = button.getAttribute('data-sample-parent-product-title') || 'Product';

      if (!sampleVariantId) {
        alert('Sample is not configured for this product.');
        return;
      }

      addSingleSample(button, sampleVariantId, parentProductId, parentProductTitle);
    });
  });

  function addSingleSample(button, sampleVariantId, parentProductId, parentProductTitle) {
    var originalText = button.textContent.trim();

    button.disabled = true;
    button.textContent = 'Checking Sample...';

    fetch(getShopifyRoot() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Could not check cart.');
        }

        return response.json();
      })
      .then(function (cart) {
        var alreadyInCart = cart.items.some(function (item) {
          var sameVariant = String(item.variant_id) === String(sampleVariantId);

          var sameParentProduct =
            item.properties &&
            item.properties._sample_parent_product_id &&
            String(item.properties._sample_parent_product_id) === String(parentProductId);

          return sameVariant || sameParentProduct;
        });

        if (alreadyInCart) {
          alert('This sample is already in your cart. Only one sample can be ordered at a time.');
          window.location.href = getShopifyRoot() + 'cart';
          return null;
        }

        button.textContent = 'Adding Sample...';

        return fetch(getShopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(sampleVariantId),
            quantity: 1,
            properties: {
              '_sample_item': 'true',
              '_sample_parent_product_id': parentProductId || '',
              'Sample For': parentProductTitle
            }
          })
        });
      })
      .then(function (response) {
        if (!response) return null;

        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function (item) {
        if (!item) return;

        window.location.href = getShopifyRoot() + 'cart';
      })
      .catch(function (error) {
        console.error('Order sample error:', error);

        alert(
          error.description ||
          error.message ||
          'This sample could not be added to cart.'
        );

        button.disabled = false;
        button.textContent = originalText || 'Order Sample';
      });
  }

  function getShopifyRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }

    return '/';
  }
})();